<template>
  <div class="inventoryTransferSend">
    <h2>调拨（调出）</h2>
    <el-form :inline="true">
      <el-form-item label="调出日期">
        <el-date-picker v-model="searchParam.outDates" type="daterange" start-placeholder="起" end-placeholder="止" style="width: 220px;" />
      </el-form-item>
      <el-form-item label="调出仓储">
        <el-select v-model="searchParam.outStorage" filterable style="width: 120px;" clearable>
          <el-option v-for='storageItem in show.storageList' :key="storageItem.id" :label="storageItem.value" :value="storageItem.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="调入仓储">
        <el-select v-model="searchParam.inStorage" filterable style="width: 120px;" clearable>
          <el-option v-for='storageItem in show.storageList' :key="storageItem.id" :label="storageItem.value" :value="storageItem.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="运输公司">
        <el-select v-model="searchParam.transportCompany" filterable style="width: 120px;" clearable>
          <el-option v-for='transportCompanyItem in show.transportCompanyList' :key="transportCompanyItem.id" :label="transportCompanyItem.value" :value="transportCompanyItem.value" />
        </el-select>
      </el-form-item>
      <el-form-item label="车号">
        <el-autocomplete v-model="searchParam.truckNumber" style="width: 120px;" :fetch-suggestions="getTruckNumbers" clearable />
      </el-form-item>
      <el-form-item label="调入状态">
        <el-select v-model="searchParam.hasIn" style="width: 110px;" clearable>
          <el-option label="运输中" :value="false" />
          <el-option label="已调入" :value="true" />
        </el-select>
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="commitFindList()">搜索</el-button>
          <el-button @click="resetSearchParam()">重置</el-button>
        </el-button-group>
      </el-form-item>
      <el-form-item>
        <el-button-group>
          <el-button type="primary" @click="add()">新建</el-button>
          <el-button type="warning" :disabled="!(show.selected.length == 1)" @click="update()">详情</el-button>
          <el-button type="danger" :disabled="!(show.selected.length >= 1)" @click="del()" :loading="show.saving">删除</el-button>
        </el-button-group>
      </el-form-item>
    </el-form>
    <el-table :data="data.list" @selection-change="selectionChange()" ref="tabRef" border show-summary :summary-method="summary" style="height: calc(100vh - 310px);">
      <el-table-column type="selection" width="55" align="center" />
      <el-table-column width="55" align="center">
        <template #default="scope">
          <el-link type="primary" @click="update(scope.row)">详情</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="outDate" label="调出日期" width="110" show-overflow-tooltip />
      <el-table-column label="调入状态" width="90" align="center">
        <template #default="scope">
          <el-text v-if="scope.row.inDate" type="success">已调入</el-text>
          <el-text v-else type="warning">运输中</el-text>
        </template>
      </el-table-column>
      <el-table-column prop="outStorage" label="调出仓储" width="120" show-overflow-tooltip />
      <el-table-column prop="inStorage" label="调入仓储" width="120" show-overflow-tooltip />
      <el-table-column prop="transportCompany" label="运输公司" width="120" show-overflow-tooltip />
      <el-table-column prop="truckNumber" label="车牌号" width="110" show-overflow-tooltip />
      <el-table-column label="配比" width="220" show-overflow-tooltip>
        <template #default="scope">
          {{ mixString(scope.row) }}
        </template>
      </el-table-column>
      <el-table-column prop="outQuantityGross" label="重车数量" width="100" align="right">
        <template #default="scope">{{ math.formatNumber(scope.row.outQuantityGross) }}</template>
      </el-table-column>
      <el-table-column prop="outQuantityTare" label="皮重数量" width="100" align="right">
        <template #default="scope">{{ math.formatNumber(scope.row.outQuantityTare) }}</template>
      </el-table-column>
      <el-table-column prop="outExpandedQuantity" label="涨吨数量" width="100" align="right">
        <template #default="scope">{{ math.formatNumber(scope.row.outExpandedQuantity) }}</template>
      </el-table-column>
      <el-table-column prop="outQuantityInitial" label="出库数量" width="100" align="right">
        <template #default="scope">{{ math.formatNumber(scope.row.outQuantityInitial) }}</template>
      </el-table-column>
      <el-table-column prop="outQuantity" label="调出数量" width="100" align="right">
        <template #default="scope">{{ math.formatNumber(scope.row.outQuantity) }}</template>
      </el-table-column>
      <el-table-column prop="productAmount" label="总成本" width="120" align="right">
        <template #default="scope">{{ math.formatNumber(productAmount(scope.row)) }}</template>
      </el-table-column>
      <el-table-column prop="transferTransportPrice" label="调拨运费单价" width="120" align="right">
        <template #default="scope">{{ math.formatNumber(scope.row.transferTransportPrice) }}</template>
      </el-table-column>
      <el-table-column prop="customNote" label="销售品名" width="140" show-overflow-tooltip />
      <el-table-column prop="note" label="备注" width="160" show-overflow-tooltip />
      <el-table-column prop="operateOutDatetime" label="操作调出时间" width="170" show-overflow-tooltip />
      <el-table-column prop="createDatetime" label="新增时间" width="170" show-overflow-tooltip />
    </el-table>
    <div style="height: 10px;" />
    <el-pagination v-model:current-page="searchParam.pageNum" v-model:page-size="searchParam.pageSize" :page-sizes="[300, 500, 1000, 2000]" background layout="total, sizes, prev, pager, next, jumper" :total="data.total" @change="commitFindList()" />
  </div>
</template>

<script setup>
import { reactive, ref } from 'vue'
import { useRouter } from 'vue-router'
import { ElMessage, ElMessageBox } from 'element-plus'
import api from '../../apis/api'
import cache from '../../utils/cache'
import util from '../../utils/util'
import math from '../../utils/math'

const router = useRouter()
const tabRef = ref()

const data = reactive({
  total: 0,
  list: [],
  accumulate: {},
})

const show = reactive({
  saving: false,
  selected: [],
  storageList: [],
  transportCompanyList: [],
})

api.get('/backend/dict/getByCode', { params: { code: 'storage' } }).then(res => {
  show.storageList = res.dictList
})
api.get('/backend/dict/getByCode', { params: { code: 'transportCompany' } }).then(res => {
  show.transportCompanyList = res.dictList
})

const getTruckNumbers = (queryString, callback) => {
  api.get('/backend/inventoryTransfer/getTruckNumbers', { params: { truckNumberLike: queryString } }).then(res => {
    callback(res.list.map(item => { return { value: item } }))
  })
}

const searchParam = reactive({})
const resetSearchParam = () => {
  searchParam.pageNum = 1
  searchParam.pageSize = 300
  searchParam.outDates = []
  searchParam.outStorage = null
  searchParam.inStorage = null
  searchParam.transportCompany = null
  searchParam.truckNumber = null
  searchParam.hasIn = null
}
resetSearchParam()
const beforeSearchParam = cache.getObject(cache.keys.pageParam + 'inventoryTransferSend')
if (beforeSearchParam) {
  Object.assign(searchParam, beforeSearchParam)
  cache.setObject(cache.keys.pageParam + 'inventoryTransferSend', null)
}

const mixString = (row) => {
  if (!row.mixDetailList) {
    return ''
  }
  return row.mixDetailList.map(d => d.product + '(' + math.formatNumber(d.outQuantity) + ')').join(' : ')
}

/** 总成本 = 各品名调出数量 × 调出单价 */
const productAmount = (row) => {
  if (!row.mixDetailList) {
    return 0
  }
  let amount = 0
  for (const d of row.mixDetailList) {
    amount = math.plus(amount, math.multiply(d.outQuantity, d.inventoryProductPrice))
  }
  return amount
}

const commitFindList = () => {
  const params = {}
  params.pageNum = searchParam.pageNum
  params.pageSize = searchParam.pageSize
  if (searchParam.outDates && searchParam.outDates.length == 2) {
    params.outDateGe = util.parseTime(searchParam.outDates[0], '{y}-{m}-{d}')
    params.outDateLe = util.parseTime(searchParam.outDates[1], '{y}-{m}-{d}')
  }
  params.outStorage = searchParam.outStorage
  params.inStorage = searchParam.inStorage
  params.transportCompany = searchParam.transportCompany
  params.truckNumber = searchParam.truckNumber
  params.hasIn = searchParam.hasIn
  params.orderBy = 'outDate_desc_id_desc'
  api.get('/backend/inventoryTransfer/page', { params: params }).then(res => {
    data.list = res.list
    data.total = res.total
    data.accumulate = res.data
  })
}
commitFindList()

const summary = ({ columns }) => {
  const a = data.accumulate
  return columns.map((column, index) => {
    if (index == 0) {
      return '合计'
    }
    switch (column.property) {
      case 'outQuantityGross': return math.formatNumber(a.outQuantityGross)
      case 'outQuantityTare': return math.formatNumber(a.outQuantityTare)
      case 'outExpandedQuantity': return math.formatNumber(a.outExpandedQuantity)
      case 'outQuantityInitial': return math.formatNumber(a.outQuantityInitial)
      case 'outQuantity': return math.formatNumber(a.outQuantity)
      case 'productAmount': return math.formatNumber(a.productAmount)
      case 'transferTransportPrice': return math.formatNumber(math.divide(a.transferTransportAmount, a.inQuantityOriginal))
      default: return ''
    }
  })
}

const selectionChange = () => {
  show.selected = tabRef.value.getSelectionRows()
}

const add = () => {
  cache.setObject(cache.keys.pageParam + 'inventoryTransferSend', searchParam)
  cache.setObject(cache.keys.pageParam + 'inventoryTransferSendDetail', null)
  router.push('/inventoryTransferSendDetail')
}

const update = (row) => {
  cache.setObject(cache.keys.pageParam + 'inventoryTransferSend', searchParam)
  const transfer = row ? row : tabRef.value.getSelectionRows()[0]
  cache.setObject(cache.keys.pageParam + 'inventoryTransferSendDetail', transfer)
  router.push('/inventoryTransferSendDetail')
}

const del = () => {
  if (show.saving) {
    return
  }
  const ids = tabRef.value.getSelectionRows().map(transfer => transfer.id)
  ElMessageBox.confirm('', {
    title: '确认删除',
    message: '将要删除选中的 ' + ids.length + ' 项。删除后调出仓储的库存会退回，已调入的还会扣减调入仓储的库存。',
    autofocus: false,
    confirmButtonText: '确认',
    cancelButtonText: '取消'
  }).then(() => {
    show.saving = true
    api.post('/backend/inventoryTransfer/del', { ids: ids }).then(() => {
      ElMessage.success('删除成功')
      commitFindList()
    }).finally(() => {
      show.saving = false
    })
  })
}
</script>

<style lang="less"></style>
